// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"64335e10","703":"4acacb15"}[chunkId] + ".chunk.js";
};